import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, CenteredColBox, Link } from "../../../common/components";
import { spacing } from "../../../styles/theme";
import { OnboardingTitle } from "../Component/OnboardingTitle";
import { Button, CircularProgress, Typography } from "@mui/material";

type Reason =
  | "souvenir"
  | "other"
  | "not_distributor"
  | "new_account_awaiting_approval"
  | "existing_account_awaiting_approval"
  | "distributor_denied";

interface Props {
  reason: Reason;
  onPreviousStep?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  action?: {
    label: string;
    onClick: () => Promise<void>;
  };
}

export const OnboardingNotice = ({ reason, onPreviousStep, action }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleAction = async () => {
    setLoading(true);
    await action!.onClick();
    setLoading(false);
  };

  return (
    <Box fullWidth mt={{ xs: spacing.xlMobile, lg: 0 }}>
      <OnboardingTitle
        title={t(`attraction.onboard.onboarding_notice.title_${reason}`)}
      />
      <CenteredColBox
        gap={{ xs: spacing.regularMobile, lg: spacing.regularDesktop }}
        mt={{ xs: spacing.regularMobile, lg: spacing.regularDesktop }}
        fullWidth
      >
        <Typography textAlign="center">
          {t(`attraction.onboard.onboarding_notice.${reason}`)}
        </Typography>
        {action && (
          <Button
            variant="contained"
            onClick={handleAction}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} /> : undefined}
          >
            {action.label}
          </Button>
        )}
        {onPreviousStep && (
          <Link onClick={(e) => onPreviousStep(e)}>{t("onboard.back")}</Link>
        )}
      </CenteredColBox>
    </Box>
  );
};
